import { initialState } from "src/modals/embedded-integration-v2/constants/initialState"

export const initialPurchaseRichLinkDynamicFieldState = {
    linkTitle: { ...initialState },
    linkSubTitle: { ...initialState },
    linkUrl: { ...initialState },
    linkSvgFile: { ...initialState },
}
